import { combineEpics } from "redux-observable";
import { BootstrapEpics } from "./bootstrap/bootstrap.slice";
import { fileEpics } from "./file";
import { projectEpics } from "./project/projectEpic";
import { uploadEpics } from "./upload/uploadEpic";
import { iraiEpics } from "./irai";
import { Viewer3DEpics } from "./viewer3D.slice";
import { FilesListEpics } from "./filesList.slice";
import { TreeEpics } from "./tree.slice";
import multiViewerReducer, { MultiViewerEpics } from "./multiViewer.slice";
import { uploadFileEpics } from "./uploadFiles/uploadFileEpic";
import { convertFileEpics } from "./convertFile/convertFile.slice";
import { drawingsEpic } from "@/pages/DrawingsPage/redux/drawingsSlice";
import { teamDrivesEpic } from "@/store/teamDrives/teamDrivesSlice";
import { DOCAIEpics } from "./docai.slice";
import { extractionEpics } from "@/pages/FilePage/redux/extraction.slice";
import { modalEpics } from "@/store/modal.slice";
import { deleteFileEpics } from "./deleteFile";
import { archiveFileEpics } from "./archiveFile";
import { selectedFilesEpic } from "./selectedFiles/selectedFiles.slice";
import { permissionEpics } from "./permission/permissionEpic";
import { organizationUsersEpics } from "./organizationUsers/organizationUsersEpic";
import { navigationEpics } from "./navigation/navigationSlice";
import { organizationsEpics } from "./organizations";
import { preferencesEpics } from "./preferences";
import { contextMenuEpics } from "./contextMenu.slice";
import { authEpics } from "./auth/authSlice";
import { labelEpics } from "./labelEpic";
import { MoveEpics } from "./move/moveEpic";
import { folderUploadEpics } from "./folderUpload/folderUploadEpic";
import { driveEpics } from "./drive/driveEpic";
import { workflowEpics } from "./workflow/workflowSlice";
import { dataLoaderEpics } from "./dataLoader/dataLoaderEpic";
import { workflowAnalyticEpics } from "./workflowAnalytic/workflowAnalyticEpic";
import { groupUserEpics } from "@/pages/SettingPage/store/groupUserEpics";
import { storageEpics } from "../pages/SettingPage/StorageManagement/redux/storageEpic";
import { uploadInterceptEpics } from "./uploadIntercept/uploadInterceptEpic";

const rootEpics = combineEpics(
  ...fileEpics,
  ...BootstrapEpics,
  ...projectEpics,
  ...driveEpics,
  ...uploadEpics,
  ...uploadFileEpics,
  ...iraiEpics,
  ...Viewer3DEpics,
  ...TreeEpics,
  ...FilesListEpics,
  ...MultiViewerEpics,
  ...convertFileEpics,
  ...drawingsEpic,
  ...teamDrivesEpic,
  ...extractionEpics,
  ...modalEpics,
  ...DOCAIEpics,
  ...deleteFileEpics,
  ...archiveFileEpics,
  ...selectedFilesEpic,
  ...permissionEpics,
  ...organizationUsersEpics,
  ...navigationEpics,
  ...organizationsEpics,
  ...preferencesEpics,
  ...contextMenuEpics,
  ...labelEpics,
  ...MoveEpics,
  ...folderUploadEpics,
  ...workflowEpics,
  ...dataLoaderEpics,
  ...workflowAnalyticEpics,
  ...groupUserEpics,
  ...storageEpics,
  ...uploadInterceptEpics,

  authEpics
);

export default rootEpics;
